import { publicDomain } from "./publicDomain.js";
/** Liveblog product deep link: the gatekeeper-provided `url` when present, else built client-side. */
export function liveblogOrganizationUrl(org) {
    return org.url ?? `https://pro.${publicDomain()}/organizations/${org.id}`;
}
/**
 * Deep link into an nxt-cms Organization: its tenant's host on the `apps.<public-domain>` domain, with
 * the Organization in the path (e.g. `https://acme.apps.tickaroo.com/nxt/cms/o7k2abc123xyz`).
 */
export function nxtCmsOrganizationUrl(org) {
    return `https://${org.tenantSlug}.apps.${publicDomain()}/nxt/cms/${org.id}`;
}
//# sourceMappingURL=organizationUrls.js.map